// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../action-list';
import {getLaborTypes} from '../repositories';
import {readLaborLocations} from '../../shared/action-creators/labor-locations';

export const readLaborTypes = (dealerId, pin, suppressErrors = false) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const data = await getLaborTypes(dealerId);

            dispatch({
                data: data.laborTypes,
                type: actions.UPDATE_LABOR_TYPES_COLLECTION
            });

            readLaborLocations(dealerId, pin, suppressErrors)(dispatch);

        } catch (error) {

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/claim/shared/action-creators/labor-types.js